import { homeIcons } from '../../assets/images/home';
import { motion } from 'framer-motion';

const containerVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.3,
        },
    },
};

const itemVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
};

const PowerSection = () => {
    return (
        <section id="power">
            <div className="content">
                <div className="title">
                    <h2>Offrez à vos équipes le <span>pouvoir</span> des langues</h2>
                </div>
                <div className="text">
                    <p>
                        Préparez vos collaborateurs à briller à l’international avec Polyglow.<br />
                        Simple, efficace, et ludique, elle leur permet de maîtriser rapidement le vocabulaire et les expressions essentiels du monde des affaires.
                    </p>
                </div>

                {/* Conteneur avec effet cascade */}
                <motion.div
                    className="pros-list"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                >
                    {[1, 2, 3].map((num, index) => (
                        <motion.div key={index} className={`pros pros${num}`} variants={itemVariants}>
                            <div className="picto">
                                <img
                                    src={
                                        num === 1 ? homeIcons.lightning :
                                        num === 2 ? homeIcons.book :
                                        homeIcons.heart
                                    }
                                    alt="Pictogramme"
                                />
                            </div>
                            <div className="pros-text">
                                <h3>{num}.</h3>
                                <p>
                                    {num === 1
                                        ? "Acquisition rapide des compétences clés"
                                        : num === 2
                                        ? "Apprentissage flexible et accessible partout"
                                        : "Motivation accrue grâce à une méthode interactive"}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default PowerSection;

{/* 
import { homeIcons } from '../../assets/images/home';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const PowerSection = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: '-30% 0px' });

    return (
        <motion.section id="power"
        ref={ref}
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1.5, ease: 'easeOut' }}>
            <div className="content">
                <div className="title">
                    <h2>Offrez à vos équipes le <span>pouvoir</span> des langues</h2>
                </div>
                <div className="text">
                    <p>Préparez vos collaborateurs à briller à l’international avec Polyglow.<br />Simple, efficace, et ludique, elle leur permet de maîtriser rapidement le vocabulaire et les expressions essentiels du monde des affaires.</p>
                </div>
                <div className="pros-list">
                    <div className="pros pros1">
                        <div className="picto">
                            <img src={homeIcons.lightning} alt="Pictogramme d'un éclair" />
                        </div>
                        <div className="pros-text">
                            <h3>1.</h3>
                            <p>Acquisition rapide des compétences clés</p>
                        </div>
                    </div>
                    <div className="pros pros2">
                        <div className="picto">
                            <img src={homeIcons.book} alt="Pictogramme d'un livre" />
                        </div>
                        <div className="pros-text">
                            <h3>2.</h3>
                            <p>Apprentissage flexible et accessible partout</p>
                        </div>
                    </div>
                    <div className="pros pros3">
                        <div className="picto">
                            <img src={homeIcons.heart} alt="Pictogramme d'un coeur" />
                        </div>
                        <div className="pros-text">
                            <h3>3.</h3>
                            <p>Motivation accrue grâce à une méthode interactive</p>
                        </div>
                    </div>
                </div>
            </div>
        </motion.section>
    );
};


export default PowerSection; */}